module.exports = __webpack_public_path__ + "img/hb-active.94afd894.png";